<ng-container *ngIf="sortDirection === 1">
    <msi-icon name="ic_arrow_sort" [size]="size"/>
</ng-container>
<ng-container *ngIf="sortDirection === -1">
    <msi-icon name="ic_arrow_sort_up" [size]="size"/>
</ng-container>
